import React from "react";
import ReactDOM from "react-dom";
import SignupPage from "./SignupPage";

export default function initSignup() {
  const node = document.getElementById("app");
  const {
    termsVersion,
    verificationRequired,
  } = JSON.parse(node.dataset.props);

  ReactDOM.render(
    <SignupPage
      version={termsVersion}
      verificationRequired={verificationRequired}
    />,
    document.getElementById("app")
  );
}
